import * as signalR from "@microsoft/signalr";

let connection = null;

export const createConnection = (hubUrl, token) => {
  connection = new signalR.HubConnectionBuilder()
    .withUrl(hubUrl, {
      accessTokenFactory: () => token,
    })
    .withAutomaticReconnect([0, 2000, 5000, 10000])
    .configureLogging(signalR.LogLevel.Warning)
    .build();

  return connection;
};

export const getConnection = () => connection;
